import { ReactComponent as PlusCircle } from '../../icons/plus-circle.svg';
import { ReactComponent as CheckCircleIcon } from '../../icons/check-circle-solid.svg';
import Icon from '../common/Icon';

import './AddToService.scss';

const AddToSuggested = ({ onClick, song, suggestedSongs }) => {
  const songFound = suggestedSongs && suggestedSongs.find((s) => s._id === song._id);
  const icon = songFound ? <CheckCircleIcon /> : <PlusCircle />;
  const type = songFound ? 'solid' : 'empty';

  return (
    <div className="AddToService mg-d-block mg-text-right clickable">
      <Icon icon={icon} onClick={onClick} className={type} />
    </div>
  );
};

export default AddToSuggested;
